const pixelSizes = { 0: '0' };
// eslint-disable-next-line no-plusplus
for (let i = 1; i <= 1000; i++) {
  pixelSizes[`c${i}`] = `${i / 16}rem`;
  pixelSizes[`n${i}`] = `-${i / 16}rem`;
}

export default {
  // Avoid collision with other stylesheets.
  // See: https://tailwindcss.com/docs/configuration#prefix.
  prefix: 'au-',
  content: ['./src/**/*.{js,jsx,ts,tsx,html,twig}'],
  theme: {
    fontFamily: {
      element: ['ArtifaktElement', 'sans-serif'],
      legend: ['ArtifaktLegend', 'sans-serif'],
    },
    boxShadow: {
      default: '0 3px 7px 0 rgba(0, 0, 0, 0.1)',
      md: '0px 4px 20px rgba(0, 0, 0, 0.25)',
      none: 'none',
    },
    zIndex: {
      0: 0,
      1: 1,
      2: 2,
      10: 10,
      20: 20,
      50: 50,
      100: 100,
      n1: -1,
    },
    colors: {
      current: 'currentColor',
      transparent: 'transparent',
      black: '#000',
      white: '#fff',
      blue: {
        400: '#1858a8',
        500: '#0696d7',
      },
      green: {
        500: '#87b340',
        600: '#6a9728',
      },
      gray: {
        100: '#f5f5f5',
        200: '#ccc',
        300: '#959CB2',
        600: '#666',
        700: '#4d4d4d',
        750: '#3d3d3d',
        800: '#2a2a2a',
        900: '#999',
        b2: '#b2b2b2',
        b3: '#b3b3b3',
        e5: '#e5e5e5',
      },
      iris: '#5f60ff',
      red: {
        600: '#dd2222',
      },
    },
    extend: {
      fontSize: pixelSizes,
      lineHeight: pixelSizes,
      spacing: {
        '1/12': '8.333333%',
        half: '50%',
        min: 'min-content',
        max: 'max-content',
        fit: 'fit-content',
        offscreen: '-1000000px',
        ...pixelSizes,
      },
      width: {
        c260: '16.25rem',
        c500: '31.25rem',
        tabWidth: '21.375rem',
        ...pixelSizes,
      },
      minWidth: {
        c200: '12.5rem',
        c500: '31.25rem',
        ...pixelSizes,
      },
      maxWidth: {
        inner: '1240px',
        outer: '1440px',
        c500: '31.25rem',
        c75pc: '75%',
        ...pixelSizes,
      },
      height: {
        ...pixelSizes,
        'half-screen': '50vh',
      },
      minHeight: pixelSizes,
      colors: {
        'gray-de': '#DEDEDE',
        'gray-3c': '#3c3c3c',
        'gray-e5': '#E5E5E5',
        'gray-f5': '#f5f5f5',
        'gray-f7': '#f7f7f7',
        'gray-21': '#212121',
        'gray-cc': '#cccccc',
        'gray-4a': '#4a4a4a',
        'gray-99': '#999999',
        yellow: '#FEFF09',
        skeleton: '#DDDBDD',
        'light-detail-1-opaque-50': '#E5E5E5',
        'active-highlight': '#9CD5B8',
        'inactive-highlight': '#BDBDFF',
        'link-text': '#006eaf',
        'pagination-disabled': '#979797',
        'green-form-active': '#2BC275',
        'blue-form-hover': '#5F60FF',
        'blue-form-focus': '#8080FF',
        'red-form-error': '#D74E26',
        'red-text-error': '#C94B23',
        'red-checkbox-error': '#C34922',
        'red-danger': '#CC4B24',
        'red-coral': '#ff9582',
        adskTurquoise50: '#0ed3be',
        bahamaBlue: '#0671A1',
        'blue-engage-slight': '#EFEFFF',
        'fill-warning-slight': '#FFF9E8',
        'slate-background': '#1a1a1a',
      },
      opacity: {
        60: '.6',
      },
      backgroundImage: {
        'skeleton-line':
          'linear-gradient(90deg,rgba(255,255,255, 0) 0,rgba(255,255,255, 0.2) 20%,rgba(255,255,255, 0.5) 60%,rgba(255,255,255, 0))',
      },
      dropShadow: {
        'user-tooltip': '0 0 16px rgba(0, 0, 0, 0.16)',
        'user-menu': 'rgba(0, 0, 0, 0.25) 0px 0px 16px',
      },
      order: {
        n1: '-1',
      },
      gap: pixelSizes,
      borderRadius: pixelSizes,
      borderWidth: pixelSizes,
      boxShadow: {
        'input-hover': '0 2px 0px 0px #8080FF',
        'input-focus': '0 0px 0px 2px #5f60ff',
        'input-active': '0 2px 0px 0px #5F60FF',
        'class-nav-active': 'inset 2px 0px 0px #1278AF',
        filtersBorder:
          '0px 2px 0px rgba(0, 0, 0, 0.6), inset 1px 0px 0px rgba(0, 0, 0, 0.3), inset -1px 0px 0px rgba(0, 0, 0, 0.3), inset 0px 1px 0px rgba(0, 0, 0, 0.3)',
      },
      screens: {
        landscape: { orientation: 'landscape' },
        portrait: { orientation: 'portrait' },
        sm: '480px',
        md: '768px',
        lg: '1200px',
        xl: '1439px',
        xl2: '1601px',
      },
      animation: {
        skeleton: 'skeleton 2s infinite',
      },
      keyframes: {
        skeleton: {
          '100%': { transform: 'translateX(100%)' },
        },
      },
      flexBasis: {
        '55p': '55%', // Custom flex-basis value
      },
    },
    container: {
      center: true,
      padding: '10px',

      screens: {
        landscape: { orientation: 'landscape' },
        portrait: { orientation: 'portrait' },
        sm: '480px',
        md: '768px',
        lg: '1200px',
        xl: '1440px',
      },
    },
  },
};
